module.exports = __webpack_public_path__ + "static/img/logo-ibon@3x.6249231f.png";